<template>
  <div id="ViewDirectHours" v-if="directHoursInfo" class="wrap">

    <v-app-bar class="grey lighten-3 desktopHeader--remove hidden-md-and-up" fixed elevate-on-scroll>
      <v-layout column>
        <v-toolbar-title class="grey--text text--darken-3 font-weight-medium">{{directHoursInfo.organization_name}} </v-toolbar-title>
        <span class="caption font-weight-light"> Direct Patient Experience</span>
      </v-layout>

      <v-spacer></v-spacer>
      <v-btn  :href="`tel:${ directHoursInfo.supervisor_phone}`" icon small > <v-icon color="light-blue darken-3 " >mdi-phone</v-icon></v-btn>
      <v-btn  :href="`mailto:${directHoursInfo.supervisor_email}`" icon small > <v-icon color="light-blue darken-3 " >mdi-email</v-icon></v-btn>
      <v-btn @click="editdirectHoursInfo(directHoursInfo.id)" icon small  ><v-icon   >mdi-pencil</v-icon></v-btn>
      <RemoveDirectHours :directHoursInfo="directHoursInfo"/>
    </v-app-bar>

    <div class="HealthcareHours__cover offset-md-3 col-md-6 offset-sm-2 col-sm-8 px-0 ">

      <!-- Total Direct Hours Container -->
      <v-container  class=" py-0 pb-0 px-0">
          <div @click="backDesktop" class="headerFake__back">
            <a class="headerFake__backLink">
              <v-icon class="mr-3" medium color="red">mdi-arrow-left</v-icon>
              <span class="headerFake__backText">Back</span>
            </a>
          </div>
        <v-card class="mt-4 card elevation-0" flat tile>
          <v-card-title class="px-0 hidden-sm-and-down">

                <v-layout column>
                  <v-toolbar-title class="grey--text text--darken-3 font-weight-medium">{{directHoursInfo.organization_name}} </v-toolbar-title>
                  <span class="caption font-weight-light"> Direct Patient Experience</span>
                </v-layout>

                <v-spacer></v-spacer>
                <v-btn  :href="`tel:${ directHoursInfo.supervisor_phone}`" icon small > <v-icon color="light-blue darken-3 " >mdi-phone</v-icon></v-btn>
                <v-btn  :href="`mailto:${directHoursInfo.supervisor_email}`" icon small > <v-icon color="light-blue darken-3 " >mdi-email</v-icon></v-btn>
                <v-btn @click="editdirectHoursInfo(directHoursInfo.id)" icon small  ><v-icon   >mdi-pencil</v-icon></v-btn>
                <RemoveDirectHours :directHoursInfo="directHoursInfo"/>

          </v-card-title>
          <v-container pb-1 >
            <v-layout row align-center justify-center>
              <v-layout column align-center>
                <span class="percentageValue display-3 blue__text__color font-weight-medium ">{{totalHours | round }} </span>
                <p class="mt-2 grey--text ">Total Hours</p>
              </v-layout>
            </v-layout>
          </v-container>
        </v-card>
      </v-container>
      <v-container mt-2 px-0 pt-0 pb-5 style="marginBottom:50px;">
        <!-- Log Hours Button -->
        <v-card flat >
          <v-layout  align-center justify-center style="height:50px">
            <v-btn  @click="showLogDirectHours(directHoursInfo.id)" class="mr-1 pa-2 elevation-5" block  dark large color="#D49129">Log Hours</v-btn>
          </v-layout>
          <v-card-text class="px-1 pb-0">
            <v-container v-if="totalHours <= 0" class="pb-1 pa-4">
              <p class=" text-center body-1 ">No hours logged</p>
            </v-container>
          </v-card-text>
        </v-card>
        <!-- User Logged Dates and Hours -->
        <v-card v-for="loggedHour in directHoursInfo.logged_hours" :key="loggedHour.id" class=" mt-2 mx-1 mb-5 pb-2" style="borderRadius:5px" id="buttonShadow">
          <v-card-title class="pa-0">
            <v-layout class="grey lighten-3" align-center>
              <v-layout v-if=" loggedHour.date !== '' && loggedHour.date !== null && loggedHour.date !== undefined && (loggedHour.from_date === '' || loggedHour.from_date === null || loggedHour.from_date === undefined)" class="grey lighten-3" py-2>
                <v-icon small class="ml-2">mdi-calendar</v-icon>
                <p class="subtitle-1 text--primary ml-2 mb-0">{{loggedHour.date | moment(" MM/DD/YYYY") }}</p>
              </v-layout>
              <v-layout v-if="loggedHour.from_date !== '' && loggedHour.from_date !== null && loggedHour.from_date !== undefined && loggedHour.to_date !== null && loggedHour.to_date !== undefined && loggedHour.to_date !== ''" class="grey lighten-3" py-2>
                <v-icon small class="ml-2">mdi-calendar</v-icon>
                <p class="subtitle-1 text--primary ml-2 mb-0">{{loggedHour.from_date | moment(" MM/DD/YYYY") }} - {{loggedHour.to_date | moment(" MM/DD/YYYY") }}</p>
              </v-layout>
              <v-spacer></v-spacer>
              <v-icon @click="editDirectHours(directHoursInfo,loggedHour)" class="mr-2">mdi-pencil</v-icon>
              <RemoveLoggedDirectHours  :directHoursInfo="directHoursInfo" :loggedHour="loggedHour" />
            </v-layout>
          </v-card-title>
          <v-card-text class="pb-0 pt-2 pl-0 ">
            <v-layout v-if=" loggedHour.date !== '' && loggedHour.date !== null && loggedHour.date !== undefined" column  align-center justify-center>
              <span class="green--text font-weight-medium display-1" >{{loggedHour.hours}}</span>
              <span > Hours</span>
            </v-layout>
            <v-layout v-if="loggedHour.date_range_hours !== '' && loggedHour.date_range_hours !== null && loggedHour.date_range_hours !== undefined " column  align-center justify-center>
              <span class="green--text font-weight-medium display-1" >{{ loggedHour.date_range_hours}}</span>
              <span > Hours</span>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>

    </div>
    <!-- Back Button -->
    <v-btn  class="mr-4 ml-2 fixed elevation-0 " color="red"  fab rounded small @click="back"> <v-icon  medium color="white">mdi-arrow-left</v-icon></v-btn>
  </div>

</template>

<script>
  export default {
     data() {
      return {
        modal: false,
        alert: false,
        date2: '',

      }
    },
    methods: {
      back() {
        this.$router.go(-1);
      },
      backDesktop () {
        this.$router.push('/dashboard');
      },
      showLogDirectHours (id) {
        this.$router.push('/dashboard/healthcarehours/logdirectexperience/' + id)
      },
      editdirectHoursInfo (id) {
         this.$router.push('/dashboard/healthcarehours/editdirectexperience/' + id)
      },
      editDirectHours(directHoursInfo,loggedHour) {
        this.$router.push('/dashboard/healthcarehours/editdirecthours/' + directHoursInfo.id + '/' + loggedHour.id)

      },
    },
    computed : {
      id () {
        return this.$route.params.id
      },
      user () {
        return this.$store.getters.user
      },
      loggedHours() {
        const loggedHours = []
        for(var h = 0; h < this.directHours.logged_hours.length; h++) {
          loggedHours.push(this.directHours.logged_hours[h].date)
        }
        return loggedHours
      },
      directHoursInfo () {
        return this.$store.getters.directHoursInfo(this.id)
      },
       totalHours () {
          return this.directHoursInfo.logged_hours.reduce((sum, loggedHours)=> {
             return sum + parseFloat(loggedHours.hours)
        }, 0)
      },
    },
  }
</script>

<style scoped>

#schoolToolbar {
  position: sticky;
  box-shadow: 0 10px 30px -10px #11111130;
}
.closeButton {
  bottom: 0;
  top:695px;
  background-color: white;

}

.calendar{
  border-radius: 5px;
}

#buttonShadow {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}

.fixed {
  position: fixed;
  bottom: 0;
  right: 0;
  margin-bottom:65px;
}

@media (min-width: 960px) {
  .desktopHeader {
    width: calc(100% - 256px);
    margin-left: 256px;
  }
}
.headerFake__back {
  text-align: left;
  position: relative;
  display: none;
  padding-bottom: 40px;
}
.headerFake__backLink {
  cursor: pointer;
}
.headerFake__backText {
  position: absolute;
  top: 0;
  left: 32px;
  line-height: 26px;
  color: initial;
}

@media (min-width: 960px) {
  .headerFake__back {
    display: block;
  }
  .fixed {
    display: none;
  }
}

.wrap {
  margin-top: 8vh !important;
}

.blue__text__color {
  color:#005880;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ExperienceHours/DirectHours/ViewDirectHours.vue